module.exports = __webpack_public_path__ + "static/media/yelp.eeb54b85.svg";